"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Time = function Time() {
  return _react2.default.createElement(
    "g",
    { id: "time" },
    _react2.default.createElement("path", {
      d: "M280.21,91.44 L246.88,91.44 L246.88,266.91 L367.9,355.22 L388.59,328.11 L280.21,249.75 L280.21,91.44 L280.21,91.44 Z M250,0 C112.14,0 -2.84217094e-14,112.16 -2.84217094e-14,250 C-2.84217094e-14,387.84 112.14,500 250,500 C387.86,500 500,387.87 500,250 C500,112.13 387.86,0 250,0 L250,0 Z M250,450 C139.71,450 50,360.3 50,250 C50,139.7 139.71,50 250,50 C360.29,50 450,139.73 450,250 C450,360.27 360.29,450 250,450 L250,450 Z",
      id: "Combined-Shape"
    })
  );
};

exports.default = Time;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Time.js
// module id = 2998
// module chunks = 4